<template>
  <div>

    <v-data-table
      :headers="headers"
      max-width="100%"
      :items="volunteers"
      :loading="loading"
      :items-per-page="itemsPerPage"
      @page-count="pageCount = $event"
      :page.sync="page"
      item-key="id"
      hide-default-footer
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Volunteers</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-row class="ml-2">
              <export-list :volunteers="volunteers" />
              <v-spacer></v-spacer>
          <v-btn
            @click="showFilterModal = true"
            color="teal accent-4"
            depressed
            dark
            class="mb-1 mr-3"
          >
            <v-icon left dark>mdi-filter-variant</v-icon>Filter
          </v-btn>
              <v-col class="col--padding ml-3" lg="6">
              <v-select
                class="mr-3"
                v-model="townshipId"
                placeholder="choose township..."
                hide-details
                outlined
                dense
                item-text="name"
                item-value="id"
                @change="getVolunteerByTwnId"
                :items="townships"
              >
              </v-select>
            </v-col>
          </v-row>

          <v-spacer></v-spacer>
        </v-toolbar>
      </template>

      <template v-slot:item="{ index, item }">
        <tr>
          <td>{{ index + 1 }}</td>
          <td>{{ item.code }}</td>
          <td>{{ item.name }}</td>
          <td>{{ item.age }}</td>
          <td>{{ item.gender == 1 ? "male" : "female" }}</td>
          <td>{{ item.address }}</td>
          <td>{{ item.phone }}</td>
          <td>{{ item.both_mdr_picts == 1 ? "No" : "Yes" }}</td>
          <td>
            {{
              item.education_status == 1
                ? "higher"
                : item.education_status == 2
                ? "primary"
                : "secondary"
            }}
          </td>
          <td>
            {{
              item.occupation == 1
                ? "AM"
                : item.occupation == 2
                ? "CHW"
                : "Other"
            }}
          </td>
          <td>{{ item.township.name }}</td>
          <td>{{ item.remark }}</td>
          <td>
            <v-btn
              @click="goTrainingPage(item)"
              icon
              color="grey darken-1"
              class="white--text"
              depressed
            >
              <v-icon> mdi-notebook-edit-outline </v-icon>
            </v-btn>
          </td>
        </tr>
      </template>
    </v-data-table>
    <div class="text-center py-3">
      <v-pagination
        color="purple accent-4"
        v-model="page"
        :length="pageCount"
      ></v-pagination>
    </div>

    <filter-box
      v-bind:dialog="showFilterModal"
      @cancel="showFilterModal = false"
    />
  </div>
</template>

<script>
import { mapState } from "vuex";
import ExportList from './exportList.vue';
import FilterBox from "./FilterBox.vue";
export default {
  props: {
    volunteers: {
      type: Array,
    },
    townships: {
      type: Array,
    },
  },
 components: {
    ExportList,FilterBox
  },
  data: () => ({
    showFilterModal: false,
    townshipId: null,
    pageCount: 0,
    page: 1,
    itemsPerPage: 10,
    item: {},
    headers: [
      {
        text: "No",
        value: "no",
        class: ["header--text", "header"],
        align: "center",
        sortable: false,
      },
      {
        text: "Code",
        value: "code",
        class: ["header--text", "header"],
        align: "center",
      },
      {
        text: "Name",
        value: "name",
        class: ["header--text", "header"],
        align: "center",
        sortable: false,
        width: 150,
      },
      {
        text: "Age",
        value: "age",
        class: ["header--text", "header"],
        align: "center",
        sortable: false,
      },
      {
        text: "Gender",
        value: "gender_name",
        class: ["header--text", "header"],
        align: "center",
        sortable: false,
      },
      {
        text: "Address",
        value: "address",
        class: ["header--text", "header"],
        align: "center",
        sortable: false,
        width: 250,
      },
      {
        text: "Phone",
        value: "phone",
        class: ["header--text", "header"],
        align: "center",
        sortable: false,
      },
      {
        text: "MDR & PICTS",
        value: "both_mdr_picts",
        class: ["header--text", "header"],
        align: "center",
        sortable: false,
      },
      {
        text: "Education Status",
        value: "education_status_name",
        class: ["header--text", "header"],
        align: "center",
        sortable: false,
        width: 220,
      },
      {
        text: "Occupation",
        value: "occupation_name",
        class: ["header--text", "header"],
        align: "center",
        sortable: false,
      },
      {
        text: "Township",
        value: "township",
        class: ["header--text", "header"],
        align: "center",
        sortable: false,
        width: 220,
      },
      {
        text: "Remark",
        value: "remark",
        width: "250",
        class: ["header--text", "header"],
        align: "center",
        sortable: false,
      },
      {
        text: "Training",
        value: "training",
        class: ["header--text", "header"],
        align: "center",
        sortable: false,
      },
    ],
  }),
  computed: {
    ...mapState("Loading", ["loading"]),
  },
  methods: {
    getVolunteerByTwnId(townshipId) {
      this.$store.dispatch("Volunteer/getVolunteerByTwnId", townshipId);
    },
    goTrainingPage(item) {
      let convertNumber = parseInt(item.id);
      this.$router.push({
        name: "training",
        params: {
          id: convertNumber,
        },
      });
    },
  },
};
</script>

<style scoped>
</style>
